
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import MissionDashboard from './components/MissionDashboard';
import EcommerceIntegration from './components/EcommerceIntegration';
import PartnerMerchandise from './components/PartnerMerchandise';
import Testimonials from './components/Testimonials';
import Features from './components/Features';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <MissionDashboard />
      <EcommerceIntegration />
      <PartnerMerchandise />
      <Testimonials />
      <Features />
      <Footer />
    </div>
  );
}
